import {
    Routes,
    Route,
    NavLink,
    Navigate,
    useNavigate,
    useLocation
} from 'react-router-dom';
import authService from "./components/api-authorization/AuthorizeService"
import axios from './services/ApiService'
import { useEffect, useRef, useState } from 'react'

const ProtectedRoute = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [result, setResult] = useState(null);
    const [user, setUser] = useState({
        FirstName: "",
        LastName: "",
        name: ""
    });
    let _subscription = useRef(0);
    const location = useLocation();

    useEffect(() => {
        _subscription.current = authService.subscribe(() => populateState());
        populateState();
        console.log("");
        return (() => {
            authService.unsubscribe(_subscription.current);
        })
    }, [location.pathname]);

    const populateState = async () => {
        const [isUserAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
        setIsAuthenticated(isUserAuthenticated);
        setUser(user);
        if (!isUserAuthenticated) {
            const params = new URLSearchParams(window.location.search);
            let configParam = params.get("config");
            if (configParam) {
                localStorage.setItem("smmpviewconfig", configParam);
            }
            else {
                localStorage.setItem("smmpviewconfig", "");
            }
            setResult(<Navigate to="/authentication/login" replace />);
        }
        try {
            const res = await axios('weatherforecast');
            if (location.pathname == '/introduction') {
                setResult(<Navigate to="/" replace />)
            }
            else {
                setResult(children);
            }
            //return children;
        }
        catch (ex) {
            console.log(location.pathname);
            if (location.pathname != "/introduction" && ex.response?.data.title == "Not Eligible for Role(s)") {
                window.location.replace('/introduction');
                //setResult(<Navigate to="/introduction" replace />);
                //return <Navigate to="/introduction" replace />;
            }
            else {
                setResult(children);
            }
        }
        //await axios.get('weatherforecast').then((response) => {
        //    console.log(response);
        //    return children;
        //}).catch((error) => {
        //    if (error.response?.data.title == "Not Eligible for Role(s)") {
        //        return <Navigate to="/introduction" replace />;
        //    }
        //    console.log(error);
        //});
    }
    return result;
};

export default ProtectedRoute;